import { BoxGeometry, Group, Mesh, MeshLambertMaterial, Scene, SphereGeometry } from 'three';
import { HALF_CITY } from '../../config/settings';
import { Updatable } from '../../core/types';
import { randFloat } from '../../utils/random';

/** A single advertising blimp drifting slowly across the sky. */
export class Blimp implements Updatable {
  private readonly group = new Group();
  private readonly speed = 9;
  private readonly bound = HALF_CITY + 120;
  private elapsed = 0;

  constructor(scene: Scene) {
    const hull = new Mesh(new SphereGeometry(14, 18, 14), new MeshLambertMaterial({ color: 0xd23b3b }));
    hull.scale.set(2.4, 1, 1);
    this.group.add(hull);

    const finV = new Mesh(new BoxGeometry(7, 9, 0.6), new MeshLambertMaterial({ color: 0xffffff }));
    finV.position.x = 28;
    const finH = finV.clone();
    finH.rotation.x = Math.PI / 2;
    this.group.add(finV, finH);

    const gondola = new Mesh(new BoxGeometry(7, 2.6, 3.2), new MeshLambertMaterial({ color: 0x2a2a2a }));
    gondola.position.y = -9;
    this.group.add(gondola);

    this.group.position.set(-this.bound, 235, randFloat(-60, 60));
    scene.add(this.group);
  }

  update(dt: number): void {
    this.elapsed += dt;
    this.group.position.x += this.speed * dt;
    if (this.group.position.x > this.bound) this.group.position.x = -this.bound;
    this.group.rotation.y = Math.sin(this.elapsed * 0.2) * 0.06;
  }
}
